import { LTitle } from "@components";
import { Route, Routes, useLocation } from "react-router-dom";
import { NavItems } from "../../../common/helpers/navigation";
import { SignupLandingShell } from "../components/SignupLandingShell";
import { ContactConfirm } from "./contactConfirm";
import { ContactSales } from "./contactSales";
import { CreatedAccount } from "./createdAccount";
import { SignupMainContactInfo } from "./mainContactInfo";
import { SignupOrgInfo } from "./orgInfo";
import { SetupAccount } from "./setupAccount";
import { SignupTerms } from "./signupTerms";

const ContactSalesLeftSide = (): JSX.Element => {
    return (
        <div className="mt-5 pl-5" style={{ maxWidth: "40%" }}>
            <LTitle size="5">{"Contact Sales Teams"}</LTitle>
            <p>Fill out the form and a sales team member will be in touch soon.</p>
            <p className="mt-3">
                We’ll get back to you in <span className="has-text-weight-bold">1-2 business days.</span>
            </p>
        </div>
    );
};

export const SignupLanding = (): JSX.Element => {
    const { pathname } = useLocation();

    const leftSide = pathname === NavItems.Signup.ContactSales.path ? ContactSalesLeftSide() : <></>;

    return (
        <SignupLandingShell floatingLeftElement={leftSide}>
            <Routes>
                <Route path="*" element={<SignupMainContactInfo />} />
                <Route path={NavItems.Signup.UserCreated.relativePath} element={<CreatedAccount />} />
                <Route path={NavItems.Signup.OrgInfo.relativePath} element={<SignupOrgInfo />} />
                <Route path={NavItems.Signup.Terms.relativePath} element={<SignupTerms />} />
                <Route path={NavItems.Signup.ContactSales.relativePath} element={<ContactSales />} />
                <Route path={NavItems.Signup.ContactConfirm.relativePath} element={<ContactConfirm />} />
                <Route path={NavItems.Signup.SetupAccount.relativePath} element={<SetupAccount />} />
            </Routes>
        </SignupLandingShell>
    );
};
